import { configureStore, createSlice, PayloadAction } from '@reduxjs/toolkit';
import Cookies from 'js-cookie';
import { ACCESS_TOKEN } from '../util/constants/APP_RESERVED_NAME';
import { getCookie } from '../util/storage/cookies';

interface AuthState {
  authenticated: boolean;
  user: any | null;
}

// Obtener el usuario del almacenamiento local
const user = localStorage.getItem('asg_user')
  ? JSON.parse(localStorage.getItem('asg_user') || '{}')
  : null;

const initialState: AuthState = {
  authenticated: !!user,
  user
};

const ClearStorage = () => {
  const amountStorage = localStorage.length;
  const item_list: string[] = [];
  for (let i = 0; i < amountStorage; i++) {
    const item = localStorage.key(i);

    if (!!item && item.includes("asg_")) {
      item_list.push(item);
    }
  }

  for (const item of item_list) {
    localStorage.removeItem(item)
  }

  document.cookie = 'ASG_ACCESS_TOKEN=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
}


// Crear un slice para manejar el estado de autenticación
const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    loginSuccess: (state, action: PayloadAction<any>) => {
      state.authenticated = true;
      state.user = action.payload.user;
      localStorage.setItem('asg_user', JSON.stringify(action.payload.user));
      Cookies.set(ACCESS_TOKEN, action.payload.access_token, {
        expires: new Date(action.payload.expirationDate),
        path: '/'
      })
    },
    loginFail: (state) => {
      state.authenticated = false;
      state.user = null;
    },
    logoutSuccess: (state) => {
      state.authenticated = false;
      state.user = null;
      ClearStorage();
    },
    checkAuth: (state) => {
      const token = getCookie(ACCESS_TOKEN);
      if (token) {
        state.authenticated = true;
      } else {
        state.authenticated = false;
        state.user = null;
        ClearStorage();
      }
    },
  },
});

// Exportar las acciones generadas
export const { loginSuccess, loginFail, logoutSuccess, checkAuth } = authSlice.actions;

// Configurar el store
const store = configureStore({
  reducer: {
    auth: authSlice.reducer,
  },
});

// Exportar el store

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export default store;
